module.exports = __webpack_public_path__ + "img/square-8.2cb6b077.svg";